import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { PageBase } from "../../../Components/PageBase";
import "./PerfilProyecto.css";
import back from "../../../icons/arrow-back.svg";
import { useRol } from "../../../Context";

function PerfilProyecto() {
    const navigate = useNavigate()

    const {
        companies,
        company,
        setCompany,
        vacant_name,
        setVacant_name,
        cityP,
        setCity,
        state,
        setState,
        property_type,
        setProperty_type,
        type_license,
        setType_license,
        period_license,
        setPeriod_license,
        end_date,
        setEnd_date,
        handlePatchProyecto
    } = useRol();

    return (
        <>
            <PageBase />
            <div className="main-content">
                <div className="card-principal-perfilProyecto">
                    <div className="card-title-perfilProyecto">
                        <div>
                            <NavLink to={'/Proyectos'} className="nav-links">
                                <div className="button-back-perfilProyecto">
                                    <img src={back} alt="back" />
                                    <label>Regresar a tablero proyectos</label>
                                </div>
                            </NavLink>
                        </div>
                        <div className="label-title-perfilProyecto">
                            <label>Información del proyecto</label>
                        </div>
                    </div>
                    <div className="content-data-perfilProyecto">
                        <div className="data12-perfilProyecto">
                            <label>Empresa:</label>
                            <select value={company} onChange={(e) => setCompany(e.target.value)}>
                                {companies?.map((company) => (
                                    <option key={company.id} value={company.id}>{company.trade_name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="data12-perfilProyecto">
                            <label>Nombre del desarrollo:</label>
                            <input
                                type="text"
                                value={vacant_name}
                                onChange={(e) => setVacant_name(e.target.value)} />
                        </div>
                        <div className="data12-perfilProyecto">
                            <label>Ciudad:</label>
                            <input
                                type="text"
                                value={cityP}
                                onChange={(e) => setCity(e.target.value)} />
                        </div>
                        <div className="data6-perfilProyecto">
                            <label>Estado:</label>
                            <select
                                value={state}
                                onChange={(e) => setState(e.target.value)}>
                                <option value="0"></option>
                                <option value="Aguascalientes">Aguascalientes</option>
                                <option value="Baja California">Baja California</option>
                                <option value="Baja California Sur">Baja California Sur</option>
                                <option value="Campeche">Campeche</option>
                                <option value="Chiapas">Chiapas</option>
                                <option value="Chihuahua">Chihuahua</option>
                                <option value="Coahuila">Coahuila</option>
                                <option value="Colima">Colima</option>
                                <option value="Durango">Durango</option>
                                <option value="Guanajuato">Guanajuato</option>
                                <option value="Guerrero">Guerrero</option>
                                <option value="Hidalgo">Hidalgo</option>
                                <option value="Jalisco">Jalisco</option>
                                <option value="Estado de México">Estado de México</option>
                                <option value="Michoacán">Michoacán</option>
                                <option value="Morelos">Morelos</option>
                                <option value="Nayarit">Nayarit</option>
                                <option value="Nuevo León">Nuevo León</option>
                                <option value="Oaxaca">Oaxaca</option>
                                <option value="Puebla">Puebla</option>
                                <option value="Querétaro">Querétaro</option>
                                <option value="Quintana Roo">Quintana Roo</option>
                                <option value="San Luis Potosí">San Luis Potosí</option>
                                <option value="Sinaloa">Sinaloa</option>
                                <option value="Sonora">Sonora</option>
                                <option value="Tabasco">Tabasco</option>
                                <option value="Tamaulipas">Tamaulipas</option>
                                <option value="Tlaxcala">Tlaxcala</option>
                                <option value="Veracruz">Veracruz</option>
                                <option value="Yucatán">Yucatán</option>
                                <option value="Zacatecas">Zacatecas</option>
                            </select>
                        </div>
                        <div className="data6-perfilProyecto">
                            <label>Tipo:</label>
                            <select value={property_type} onChange={(e) => setProperty_type(e.target.value)}>
                                <option value="null"></option>
                                <option value="Casa">Casa</option>
                                <option value="Departamento">Departamento</option>
                                <option value="Terreno">Terreno</option>
                            </select>
                        </div>
                        <div className="data3-perfilProyecto">
                            <label>Tipo de Licencia:</label>
                            <select value={type_license} onChange={(e) => setType_license(e.target.value)}>
                                <option value="null"></option>
                                <option value="Paquete Premium">Paquete Premium</option>
                                <option value="Paquete Free">Paquete Free</option>
                                <option value="Paquete Expert">Paquete Expert</option>
                            </select>
                        </div>
                        <div className="data3-perfilProyecto">
                            <label>Periodo de Licencia:</label>
                            <select value={period_license} onChange={(e) => setPeriod_license(e.target.value)}>
                                <option value="null"></option>
                                <option value="Licencia Mensual">Licencia Mensual</option>
                                <option value="Licencia Anual">Licencia Anual</option>
                            </select>
                        </div>
                        <div className="data3-perfilProyecto">
                            <label>Fecha Fin de Licencia:</label>
                            <input
                                type="date"
                                value={end_date}
                                onChange={(e) => setEnd_date(e.target.value)}
                            />
                        </div>
                        <div className="data3-perfilProyecto">
                            <label>Asignación automática</label>
                            <input type="text" placeholder="No disponible" disabled readOnly />
                        </div>
                        <div className="buttons-6-perfilProyecto">
                            <button id="actual" onClick={() => {
                                handlePatchProyecto();
                                navigate('/Proyectos');
                            }}>Actualizar</button>
                            <NavLink to={'/Proyectos'} className='nav-links'>
                                <button id="cancel">Cancelar</button>
                            </NavLink>
                            <button id="elimin">Eliminar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="perfilProyecto-movil">
                <div className="container-main-movil">
                    <NavLink to={'/Proyectos'} className="nav-links-movil">
                        <div className="button-back-perfilContacto-movil">
                            <img src={back} alt="back" />
                            <label>Regresar a tablero proyectos</label>
                        </div>
                    </NavLink>
                    <div className="info-margen-perfilProyecto-movil">
                        <div className="title-profile-info-perfilContacto-movil">
                            <label>Información del proyecto</label>
                        </div>
                        <div className="container-data-perfilProyecto-movil">
                            <div className="data-perfilProyecto-movil">
                                <label>Empresa:</label>
                                <select>
                                    <option value="1">Desarrolladora Mexico Habita</option>
                                </select>
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Nombre del desarrollo:</label>
                                <input value="habita" />
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Ciudad:</label>
                                <input value="SLP" />
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Estado:</label>
                                <select name="estado">
                                    <option value="0"></option>
                                    <option value="Aguascalientes">Aguascalientes</option>
                                    <option value="Baja California">Baja California</option>
                                    <option value="Baja California Sur">Baja California Sur</option>
                                    <option value="Campeche">Campeche</option>
                                    <option value="Chiapas">Chiapas</option>
                                    <option value="Chihuahua">Chihuahua</option>
                                    <option value="Coahuila">Coahuila</option>
                                    <option value="Colima">Colima</option>
                                    <option value="Durango">Durango</option>
                                    <option value="Guanajuato">Guanajuato</option>
                                    <option value="Guerrero">Guerrero</option>
                                    <option value="Hidalgo">Hidalgo</option>
                                    <option value="Jalisco">Jalisco</option>
                                    <option value="Estado de México">Estado de México</option>
                                    <option value="Michoacán">Michoacán</option>
                                    <option value="Morelos">Morelos</option>
                                    <option value="Nayarit">Nayarit</option>
                                    <option value="Nuevo León">Nuevo León</option>
                                    <option value="Oaxaca">Oaxaca</option>
                                    <option value="Puebla">Puebla</option>
                                    <option value="Querétaro">Querétaro</option>
                                    <option value="Quintana Roo">Quintana Roo</option>
                                    <option value="San Luis Potosí">San Luis Potosí</option>
                                    <option value="Sinaloa">Sinaloa</option>
                                    <option value="Sonora">Sonora</option>
                                    <option value="Tabasco">Tabasco</option>
                                    <option value="Tamaulipas">Tamaulipas</option>
                                    <option value="Tlaxcala">Tlaxcala</option>
                                    <option value="Veracruz">Veracruz</option>
                                    <option value="Yucatán">Yucatán</option>
                                    <option value="Zacatecas">Zacatecas</option>
                                </select>
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Tipo:</label>
                                <select>
                                    <option value="0"></option>
                                    <option value="1">Casa</option>
                                    <option value="2">Departamento</option>
                                    <option value="3">Terreno</option>
                                </select>
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Tipo de Licencia:</label>
                                <select>
                                    <option value="0"></option>
                                    <option value="1">Paquete Premium</option>
                                    <option value="2">Paquete Free</option>
                                    <option value="3">Paquete Expert</option>
                                </select>
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Periodo de Licencia:</label>
                                <select>
                                    <option value="0"></option>
                                    <option value="1">Mensual</option>
                                    <option value="2">Anual</option>
                                </select>
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Fecha Fin de Licencia:</label>
                                <input type="date" />
                            </div>
                            <div className="data-perfilProyecto-movil">
                                <label>Asignación automática</label>
                                <input type="text" placeholder="No disponible" disabled />
                            </div>
                            <button className="btn-actualizar-perfilProyecto-movil">Actualizar</button>
                            <button className="btn-eliminar-perfilProyecto-movil">Eliminar</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { PerfilProyecto }